import React, { useRef, useState, useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import Comments from '../components/Comments';
import { useUser } from '../components/UserProvider';
import useAdminVerification from '../hooks/useAdminVerification';
import { useToast } from '../components/Toast';
import './interactive_maps.css';

// 건물 데이터 구조
// coords: 직사각형을 정의하는 좌표 배열 [minX, minY, maxX, maxY]
// rotation: 회전 각도 (도 단위, 0 = 회전 없음)
// center: 회전 중심점 [x, y] (선택사항, 미지정시 직사각형 중심)
const BUILDING_DATA = {
  'mosquito_lake_l': [
    // { name: '집', coords: [55.15, 99.4, 57, 101.65], rotation: -18 },
    { name: '집', coords: [55.62, 99.15, 57.35, 101.45], rotation: -18 , center: [55.6, 99.08] },
    { name: '카페', coords: [42.85, 85.05, 43.93, 87], rotation: 5 , center: [42.89, 85.03] },
    { name: '어시장', coords: [46.98, 82.85, 48.3, 84.29], rotation: -30 , center: [46.98, 82.85] },
    { name: '식료품점', coords: [46.48, 86.75, 47.48, 87.2], rotation: -5 , center: [46.48, 86.75] },
    { name: '선착장', coords: [49.7, 82.9, 50.37, 83.52], rotation: 1 , center: [49.8, 82.85] },
    { name: '철물점', coords: [47.25, 88.78, 47.65, 90.43], rotation: -5 , center: [47.25, 88.78] },
    { name: '낚시용품점', coords: [45.35, 91.4, 47.2, 93.27], rotation: -5 , center: [45.35, 91.37] },
    { name: '뜨거운 음식', coords: [46.45, 95.97, 46.95, 96.75], rotation: 34 , center: [46.45, 95.97] },
    { name: '박제 전문점', coords: [65.35, 98.55, 66.38, 99.95], rotation: -26 , center: [65.35, 98.55] },
    { name: '작업장', coords: [61.88, 92.76, 63, 94.15], rotation: 33.5 , center: [61.88, 92.76] },
    { name: '관리소', coords: [58.61, 95.55, 59.2, 97.3], rotation: 43 , center: [58.61, 95.53] },
  ],
  'american_pond_l': [
    { name: '선착장', coords: [65.55, 94, 67, 96.3], rotation: 19 , center: [65.74, 93.91] },
    { name: '작업장', coords: [61.94, 101.65, 63.45, 103.8], rotation: 27 , center: [61.94, 101.56] },
    { name: '관리소', coords: [59.05, 103, 61.6, 104.5], rotation: 26 , center: [59.13, 103] },
    { name: '식료품점', coords: [54.9, 95.53, 56.1, 96.8], rotation: -31 , center: [54.9, 95.53] },
    { name: '철물점', coords: [55.95, 96.2, 57.1, 97.45], rotation: -31 , center: [55.95, 96.2] },
    { name: '낚시용품점', coords: [57.04, 96.86, 58.2, 98.1], rotation: -31 , center: [57.04, 96.86] },
    { name: '박제 전문점', coords: [53.95, 94.76, 54.8, 96.6], rotation: -34 , center: [53.95, 94.76] },
    { name: '어시장', coords: [51.75, 92.8, 53.58, 94.7], rotation: -39 , center: [51.75, 92.8] },
    { name: '카페', coords: [46.58, 91.17, 48.61, 93.2], rotation: 17 , center: [46.63, 91.14] },
    { name: '집', coords: [119.4, 123.35, 120.55, 125.4], rotation: 33 , center: [119.4, 123.35] },
    { name: '뜨거운 음식', coords: [60.2, 98, 60.9, 99.7], rotation: 15 , center: [60.2, 98] },
  ],
  'winding_rivulet_l': [
    { name: '어시장', coords: [76.4, 91.4, 76.9, 91.9], rotation: 0 , center: [76.4, 91.4] },
    { name: '카페', coords: [75.42, 87.2, 76.39, 87.75], rotation: 0 , center: [75.42, 87.2] },
    { name: '작업장', coords: [79, 94.35, 80.43, 95.15], rotation: 19 , center: [79.09, 94.35] },
    { name: '관리소', coords: [80.63, 88.13, 82.45, 90.72], rotation: -5.5 , center: [80.63, 88.13] },
    { name: '식료품점', coords: [81.3, 93.58, 83.9, 95.3], rotation: 19 , center: [81.3, 93.58] },
    { name: '낚시용품점', coords: [80.25, 84.65, 82.45, 87.18], rotation: 4.5 , center: [80.28, 84.6] },
    { name: '철물점', coords: [87.38, 91.23, 89.7, 92.55], rotation: 33 , center: [87.4, 91.21] },
    { name: '제재소', coords: [90.5, 82.75, 93, 85], rotation: 30 , center: [90.5, 82.75] },
    { name: '농산물 직판장', coords: [82.34, 90.2, 83.9, 90.9], rotation: -5.5 , center: [82.34, 90.2] },
    { name: '야외 키친', coords: [79.19, 83.32, 79.7, 84.2], rotation: -30 , center: [79.19, 83.32] },
  ],
  'old_burg_lake_l': [
    { name: '낚시용품점', coords: [46.97, 51.77, 48.05, 52.49], rotation: -9 , center: [46.97, 51.77] },
    { name: '카페', coords: [50.2, 47, 50.8, 48.33], rotation: -20 , center: [50.2, 47] },
    { name: '어시장', coords: [44.5, 42.7, 46.7, 43.8], rotation: 0 , center: [45, 42.7] },
    { name: '식료품점', coords: [39.2, 45.5, 41.5, 46.5], rotation: 27 , center: [39.2, 46] },
    { name: '작업장', coords: [41.3, 51.75, 42.2, 52.5], rotation: 0 , center: [41.3, 51.75] },
    { name: '철물점', coords: [40, 48.6, 41, 49.8], rotation: 13 , center: [40, 48.6] },
    { name: '관리소', coords: [44.4, 48.8, 45, 50], rotation: -4 , center: [44.4, 48.8] },
    { name: '드래프트 크바스', coords: [42.6, 50.8, 43.1, 51.3], rotation: 0 , center: [42.6, 50.8] },
  ],
  'belaya_river_l': [
    { name: '카페', coords: [72.4, 46.1, 71.9, 46.6], rotation: 0 , center: [71.9, 45.1] },
    { name: '식료품점', coords: [71.9, 44.2, 72.4, 44.7], rotation: 0 , center: [71.9, 44.2] },
    { name: '낚시용품점', coords: [71.4, 42.4, 71.9, 42.9], rotation: 0 , center: [71.4, 42.4] },
    { name: '철물점', coords: [70.7, 41.4, 71.2, 41.9], rotation: 0 , center: [70.7, 41.4] },
    { name: '작업장', coords: [69.2, 42.9, 69.7, 43.4], rotation: 0 , center: [69.2, 42.9] },
    { name: '관리소', coords: [69.3, 44.6, 69.9, 45.3], rotation: -10 , center: [69.3, 44.6] },
    { name: '어시장', coords: [69.6, 45.9, 70.3, 47.1], rotation: 10 , center: [69.6, 45.9] },
    { name: '텐트', coords: [69.7, 48.3, 70.3, 48.9], rotation: 0 , center: [69.5, 47.7] },
  ],
  'kuori_lake_l': [
    { name: '카페', coords: [118.9, 120.9, 120.84, 122.6], rotation: 0 , center: [118.9, 120.9] },
    { name: '선착장', coords: [117.1, 118.59, 117.9, 119.45], rotation: 0 , center: [117.1, 118.59] },
    { name: '낚시용품점', coords: [120.85, 124.92, 122.75, 126.55], rotation: -34 , center: [120.9, 124.92] },
    { name: '관리소', coords: [114.35, 127.4, 117.55, 128.85], rotation: 7 , center: [114.35, 127.4] },
    { name: '식료품점', coords: [111.1, 125.28, 113.5, 126.55], rotation: -50 , center: [111.1, 125.28] },
    { name: '작업장', coords: [108.4, 122.8, 110.3, 124.7], rotation: -3 , center: [108.4, 122.8] },
    { name: 'KALA&Vodka', coords: [114.3, 119.5, 115.47, 120.17], rotation: -1 , center: [114.3, 119.5] },
    { name: '유제품 상점', coords: [112.1, 119.85, 113.1, 120.4], rotation: 0 , center: [112.1, 119.85] },
    { name: '철물점', coords: [109.3, 120.07, 110.1, 120.5], rotation: -2 , center: [109.3, 120.07] },
    { name: '어시장', coords: [108.1, 119.15, 108.7, 119.5], rotation: -50 , center: [108.1, 119] },
    { name: '집', coords: [102.2, 115.1, 104.7, 117.2], rotation: -44 , center: [102.2, 115.1] },
  ],
  'bear_lake_l': [
    { name: '어시장', coords: [64.9, 47.5, 65.4, 48.5], rotation: -15 , center: [64.9, 47.5] },
    { name: '식료품점', coords: [67.3, 48.2, 68.5, 48.7], rotation: -20 , center: [67.2, 48.2] },
    { name: '관리소', coords: [65.5, 49.15, 67, 50.65], rotation: 0 , center: [65.5, 49.15] },
  ],
  'volkhov_river_l': [
    { name: '선착장', coords: [163.68, 104.45, 164.84, 105.72], rotation: 0 },
    { name: '작업장', coords: [169.3, 104.75, 170.9, 105.9], rotation: 0 },
    { name: '철물점', coords: [166.86, 108.4, 168, 109.2], rotation: 0 },
    { name: '식료품점', coords: [166.86, 110.5, 168, 111.3], rotation: 0 },
    { name: '카페', coords: [168.8, 112.4, 169.9, 114.8], rotation: 0 },
    { name: '낚시용품점', coords: [172.18, 114.15, 175.3, 115.18], rotation: 54 , center: [172.2, 114.1] },
    { name: '관리소', coords: [170, 107.4, 171.8, 109], rotation: 0},
    { name: '연락선', coords: [163.9, 109.6, 164.8, 110.5], rotation: 0},
    { name: '낚시용품점', coords: [89.6, 87, 90.7, 87.8], rotation: 0},
    { name: '어시장', coords: [91.1, 87, 92.2, 87.8], rotation: 0},
    { name: '식료품점', coords: [92.6, 87, 93.7, 87.8], rotation: 0},
    { name: '연락선', coords: [92.5, 91.8, 94.3, 93.6], rotation: 0},
    { name: '식료품점(증류주)', coords: [21.8, 65.7, 23.8, 67.7], rotation: 0},
  ],
  'seversky_donets_river_l': [
    { name: '선착장', coords: [80.47, 163.45, 81.8, 164.55], rotation: 0 },
    { name: '카페', coords: [76.18, 155.85, 79.45, 157.92], rotation: -7 , center: [76.18, 155.85] },
    { name: '철물점', coords: [80.75, 157.1, 83, 158.5], rotation: 20 , center: [80.75, 157.1] },
    { name: '어시장', coords: [86, 159.3, 86.9, 161], rotation: -5 , center: [86, 159.3] },
    { name: '낚시용품점', coords: [88.2, 154, 90, 155.35], rotation: -24 , center: [88.2, 154] },
    { name: '식료품점', coords: [88.8, 147.95, 90.9, 149.45], rotation: 0 },
    { name: '베이커리', coords: [83, 138.55, 85.35, 140.05], rotation: 0 },
    { name: '방앗간', coords: [78.2, 146.9, 80.5, 149.1], rotation: 0 },
    { name: '작업장', coords: [71.3, 150.1, 73.3, 151.7], rotation: -45 , center: [71.3, 150.1] },
    { name: '바쿨라 상점(낚시용품)', coords: [67.21, 144.95, 68.45, 146.85], rotation: -20 , center: [67.26, 144.9] },
    { name: '관리소', coords: [84.60, 151.92, 85.95, 154.39], rotation: -28 , center: [84.60, 151.92] },
  ],
  'sura_river_l': [
    { name: '어시장', coords: [74.04, 37.20, 76.49, 38.74], rotation: 0 , center: [74.04, 37.20] },
    { name: '작업장', coords: [72.17, 39.27, 74.46, 40.48], rotation: -18 , center: [72.17, 39.27] },
    { name: '철물점', coords: [71.92, 43.81, 73.03, 46.35], rotation: -15 , center: [71.92, 43.81] },
    { name: '카페', coords: [79.07, 42.10, 82.5, 43.84], rotation: -18 , center: [79.07, 42.10] },
    { name: '식료품점', coords: [83.51, 43.14, 85.52, 45.36], rotation: -19 , center: [83.51, 43.14] },
    { name: '낚시용품점', coords: [88.72, 45.88, 89.84, 48.49], rotation: -30 , center: [88.92, 45.88] },
    { name: '관리소', coords: [94.02, 47.96, 96.11, 49.75], rotation: 50 , center: [94.02, 47.96] },
    { name: '농산물 직판장', coords: [63.05, 77.26, 64.30, 79.3], rotation: -23 , center: [63.05, 77.26] },
    { name: '양봉장', coords: [37.92, 88.06, 39.33, 90.26], rotation: -2 , center: [37.92, 88.06] },
  ],
  'ladoga_lake_l': [
    { name: '어시장', coords: [49.5, 68.03, 51.2, 69.37], rotation: 43 , center: [49.54, 68.03] },
    { name: '선착장', coords: [41.95, 72.56, 43.26, 74.05], rotation: 34 , center: [41.95, 72.46] },
    { name: '카페', coords: [48.79, 74.84, 50.25, 77.18], rotation: -48 , center: [48.79, 74.84] },
    { name: '작업장', coords: [51.74, 72.7, 52.74, 74.35], rotation: 44 , center: [51.74, 72.7] },
    { name: '낚시용품점', coords: [55.52, 69.85, 57.50, 71.83], rotation: 47 , center: [55.52, 69.85] },
    { name: '식료품점', coords: [51.81, 77.36, 53.21, 78.75], rotation: -49.5 , center: [51.91, 77.26] },
    { name: '관리소', coords: [54.96, 76.66, 56.24, 77.97], rotation: 47 , center: [54.96, 76.66] },
    { name: '벨루가 상점', coords: [57.10, 74.83, 58.43, 75.57], rotation: 47 , center: [57.10, 74.83] },
    { name: '철물점', coords: [58.83, 72.87, 60.50, 73.95], rotation: 47 , center: [58.83, 72.87] },
  ],
  'the_amber_lake_l': [
    { name: '관리소', coords: [14.36, 130.34, 15.5, 133.20], rotation: 0},
    { name: '제이맨 상점', coords: [13.99, 134.01, 15.45, 135.82], rotation: 0},
    { name: '식료품점', coords: [12.41, 130.24, 13.79, 131.69], rotation: 0},
    { name: '철물점', coords: [14.9, 126.17, 18.32, 127.44], rotation: 48, center: [15.17, 126.17] },
    { name: '어시장', coords: [29.36, 121.68, 30.72, 122.76], rotation: 0},
    { name: '대여점', coords: [29.65, 125.64, 30.74, 126.57], rotation: 0},
    { name: '카페', coords: [22.65, 136.3, 24.5, 137.44], rotation: 0},
    { name: '낚시용품점', coords: [25.65, 136.55, 27.02, 138], rotation: 0},
    { name: '작업장', coords: [27.58, 136.55, 29.82, 138], rotation: 0},
  ],
  'ladoga_archipelago_l': [
    { name: '어시장', coords: [239.23, 314.56, 240.45, 318.20], rotation: 0 },
    { name: '선착장', coords: [245.48, 322.39, 246.48, 323.39], rotation: -30 },
    { name: '낚시용품점', coords: [241.04, 322.72, 242.94, 325.72], rotation: 15 },
    { name: '관리소', coords: [238.00, 326.00, 241, 327], rotation: 0 },
    { name: '식료품점', coords: [236, 323, 237, 326], rotation: 0 },
    { name: '작업장', coords: [234, 319, 236, 321], rotation: -15 },
    { name: '수제루어', coords: [233.5, 317, 236, 318], rotation: 15 },
    { name: '카페', coords: [230, 322, 231, 324], rotation: 0 },
  ],
  'akhtuba_river_l': [
    { name: '어시장', coords: [87.16, 143.02, 88.94, 144.11], rotation: 5 },
    { name: '선착장', coords: [84.61, 141.74, 86.33, 142.90], rotation: 5 },
    { name: '작업장', coords: [88.38, 140.06, 89.29, 141.26], rotation: 5 },
    { name: '카페', coords: [89.13, 141.64, 89.97, 143.12], rotation: 5 },
    { name: '낚시용품점', coords: [86.66, 140.65, 87.41, 141.49], rotation: 5 },
    { name: '철물점', coords: [86.18, 137.98, 87.12, 139.31], rotation: 5 },
    { name: '수제루어', coords: [85.61, 136.17, 87.08, 137.04], rotation: 5 },
    { name: '식료품점', coords: [88.21, 137.61, 89.41, 139.28], rotation: 5 },
    { name: '관리소', coords: [88, 136.17, 89.3, 137.04], rotation: 5 },
    { name: '멜론과 수박', coords: [84.2, 133, 85.3, 133.5], rotation: 7 },
    { name: '멜론과 수박', coords: [90, 133, 90.9, 133.5], rotation: 10 },
  ],
  'copper_lake_l': [
    { name: '어시장', coords: [71.44, 59.45, 73.13, 59.97], rotation: 20 , center: [72.29, 59.71] },
    { name: '관리소', coords: [73.97, 59.99, 74.53, 60.5], rotation: -15 , center: [74.25, 60.25] },
    { name: '밑밥 믹스', coords: [74.20, 57.04, 74.68, 57.74], rotation: 10 , center: [74.20, 57.04] },
    { name: '낚시용품점', coords: [72.92, 55.38, 74.29, 56.08], rotation: -30 , center: [72.92, 55.38] },
    { name: '카페', coords: [70.22, 55.25, 71.90, 56.09], rotation: -10 , center: [70.22, 55.25] },
  ],
  'lower_tunguska_river_l': [
    { name: '어시장', coords: [86.19, 98.24, 87.24, 98.67], rotation: 20 , center: [87.24, 98.97] },
    { name: '선착장', coords: [82.04, 102.36, 84.43, 103.92], rotation: 37 , center: [82.04, 102.36] },
    { name: '카페', coords: [82.08, 106.64, 83.30, 109.15], rotation: 10 , center: [82.08, 106.64] },
    { name: '식료품점', coords: [86.36, 105.03, 87.98, 106.71], rotation: 0},
    { name: '낚시용품점', coords: [93.88, 105.21, 95.51, 107.64], rotation: 0},
    { name: '퉁구스카 아르텔', coords: [98.81, 114.53, 101.08, 116.03], rotation: 0},
    { name: '작업장', coords: [91.10, 113.91, 92.46, 115.42], rotation: 0},
    { name: '철물점', coords: [88.38, 112.84, 89.68, 113.73], rotation: 0},
    { name: '관리소', coords: [84.36, 113.29, 85.65, 116.08], rotation: 25 , center: [84.36, 113.29] },
    { name: '수제루어', coords: [87.25, 117.16, 89.19, 118.60], rotation: -35 , center: [87.25, 117.16] },
  ],
  'yama_river_l': [
    { name: '텐트', coords: [149.13, 208.10, 150.13, 208.60], rotation: -35 , center: [149.13, 208.10] },
    { name: '어시장', coords: [152.65, 210.36, 153.65, 211.36], rotation: 0},
    { name: '식료품점', coords: [154.15, 210.36, 155.15, 211.36], rotation: 0},
    { name: '철물점', coords: [155.65, 210.36, 156.65, 211.36], rotation: 0},
    { name: '카페', coords: [152.65, 206.36, 153.65, 207.36], rotation: 0},
    { name: '작업장', coords: [154.15, 206.36, 155.15, 207.36], rotation: 0},
    { name: '낚시용품점', coords: [155.65, 206.36, 156.65, 207.36], rotation: 0},
  ],
  'norwegian_sea_l': [
    { name: '낚시용품점', coords: [45, 548, 46, 547], rotation: 45 , center: [46, 547] },
    { name: '철물점', coords: [43, 547.7, 40, 548.7], rotation: 110 , center: [44, 547.7] },
    { name: 'Bjorn\'s Bait Shop(해양미끼상점)', coords: [40, 549.7, 41, 552.7], rotation: 20 , center: [40, 549.7] },
    { name: '어시장', coords: [43.5, 549.2, 44.9, 550.9], rotation: 20 , center: [45.9, 549.9] },
    { name: '카페', coords: [45, 551.5, 46.4, 553.4], rotation: 20 , center: [46.4, 553.4] },
    { name: '선착장', coords: [45.06, 555.8, 46, 557.3], rotation: -30 , center: [45.06, 555.8] },
    { name: '작업장', coords: [47, 550.5, 49, 552.5], rotation: 55 , center: [47, 550.5] },
    { name: '관리소', coords: [48, 554, 50, 556], rotation: 0 , center: [48, 554] },
  ],
  // 다른 지도에 대한 건물 데이터 추가 가능
};

// 지도 목록 (좌하단: min, 우상단: max)
const MAP_LIST = [
  { name: "모기 호수", file: "mosquito_lake_l.webp", min: [30.3, 33.85], max: [112.2, 115.75], distancePerCoord: 5 },
  { name: "엘크 호수", file: "american_pond_l.webp", min: [38.05, 38.1], max: [162.75, 162.55], distancePerCoord: 5 },
  { name: "굽이치는 개울", file: "winding_rivulet_l.webp", min: [45.15, 54.3], max: [142.1, 151.1], distancePerCoord: 5 },
  { name: "올드 버그 호수", file: "old_burg_lake_l.webp", min: [-1.86, -1.2], max: [83.1, 83.9], distancePerCoord: 5 },
  { name: "벨라야 강", file: "belaya_river_l.webp", min: [-0.35, -7.65], max: [114.8, 107.35], distancePerCoord: 5 },
  { name: "쿠오리 호수", file: "kuori_lake_l.webp", min: [53.15, 53.05], max: [149.75, 149.7], distancePerCoord: 5 },
  { name: "곰 호수", file: "bear_lake_l.webp", min: [5.251, 3.7], max: [95.551, 93.9], distancePerCoord: 5 },
  { name: "볼호프 강", file: "volkhov_river_l.webp", min: [-7.8, -9], max: [210.165, 208.805], distancePerCoord: 5 },
  { name: "세베르스키 도네츠 강", file: "seversky_donets_river_l.webp", min: [5.6, 4.64], max: [196.1, 195.1], distancePerCoord: 5 },
  { name: "수라 강", file: "sura_river_l.webp", min: [-4.5, -1.9], max: [163.09, 165.62], distancePerCoord: 5 },
  { name: "라도가 호수", file: "ladoga_lake_l.webp", min: [5.36, 0.1], max: [102.5, 97.15], distancePerCoord: 5 },
  { name: "엠버 호수", file: "the_amber_lake_l.webp", min: [-1.05, 17.9], max: [194.2, 213.1], distancePerCoord: 5 },
  { name: "라도가 군도", file: "ladoga_archipelago_l.webp", min: [-24.5, -25], max: [626, 625], distancePerCoord: 5 },
  { name: "악투바 강", file: "akhtuba_river_l.webp", min: [-6.1, -7.35], max: [208.6, 207.1], distancePerCoord: 5 },
  { name: "카퍼 호수", file: "copper_lake_l.webp", min: [24.44, 23.82], max: [78.4, 77.82], distancePerCoord: 5 },
  { name: "니즈냐야 퉁구스카 강", file: "lower_tunguska_river_l.webp", min: [-9.75, -9.8], max: [251.2, 251.1], distancePerCoord: 5 },
  { name: "야마 강", file: "yama_river_l.webp", min: [-12, -11.3], max: [310.7, 311.15], distancePerCoord: 5 },
  { name: "노르웨이 해", file: "norwegian_sea_l.webp", min: [-40.7, -40.78], max: [1037.5, 1037.1], distancePerCoord: 5 },
];
// 실제 min/max 좌표값은 각 맵에 맞게 수정 필요

const MAP_BASE_PATH = "/data/maps/";

export default function InteractiveMap() {
  const { user, isAuthenticated, getAuthHeaders } = useUser();
  const { isAdminVerified } = useAdminVerification();
  const { success, error: showError, warning, info } = useToast();
  const [searchParams, setSearchParams] = useSearchParams();
  
  // URL 파라미터에서 지도 가져오기
  const getInitialMap = () => {
    const mapParam = searchParams.get('map');
    if (mapParam) {
      // 파라미터가 파일명인 경우와 지도명인 경우 모두 처리
      const mapByFile = MAP_LIST.find(m => m.file === mapParam || m.file === `${mapParam}.webp`);
      const mapByName = MAP_LIST.find(m => m.name === mapParam);
      if (mapByFile) return mapByFile.file;
      if (mapByName) return mapByName.file;
    }
    return MAP_LIST[0].file; // 기본값: 모기 호수
  };
  
  const [selectedMap, setSelectedMap] = useState(getInitialMap());
  const containerRef = useRef(null);
  const imgRef = useRef(null); // 이미지 참조 추가
  const [crosshair, setCrosshair] = useState({ show: false, x: 0, y: 0, pageX: 0, pageY: 0 });
  const [imgSize, setImgSize] = useState({ width: 0, height: 0 });
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [drag, setDrag] = useState({ dragging: false, startX: 0, startY: 0, originX: 0, originY: 0 });
  const [linePoints, setLinePoints] = useState([]); // [{imgX, imgY, coordX, coordY}]
  const [distance, setDistance] = useState(null);
  const [clickCount, setClickCount] = useState(0);
  const [overlayKey, setOverlayKey] = useState(0); // 오버레이 리렌더링용 키
  const [searchX, setSearchX] = useState(""); // X 좌표 입력값
  const [searchY, setSearchY] = useState(""); // Y 좌표 입력값
  const [searchedPoint, setSearchedPoint] = useState(null); // 검색된 점 위치

  // 좌표 기록 모달 관련 상태
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [modalCoord, setModalCoord] = useState({ x: 0, y: 0 });
  const [locationForm, setLocationForm] = useState({
    type: 'float', // 'float', 'bottom', 'lure'
    fish: '',
    bait: '',
    memo: ''
  });
  const [savedLocations, setSavedLocations] = useState([]); // 저장된 좌표들

  // 사용법 모달 상태
  const [showHelpModal, setShowHelpModal] = useState(false);

  // 데이터 임포트 모달 상태
  const [showImportModal, setShowImportModal] = useState(false);
  const [importForm, setImportForm] = useState({
    mapName: '',
    coordData: ''
  });
  const [parsedData, setParsedData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  // 마커 툴팁 및 편집 모달 상태
  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingLocation, setEditingLocation] = useState(null);
  const [editForm, setEditForm] = useState({
    type: 'float',
    fish: '',
    bait: '',
    memo: ''
  });
  
  // 삭제 확인 모달 상태
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // 관리자용 유저 선택 상태
  const [userList, setUserList] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');
  const [userLocationCounts, setUserLocationCounts] = useState({}); // 유저별 좌표 개수

  // 오버레이 토글 상태 추가
  const [availableOverlays, setAvailableOverlays] = useState([]);
  const [activeOverlays, setActiveOverlays] = useState(new Set());

  // 좌표 검색 모달 상태
  const [coordSearchModalOpen, setCoordSearchModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchExecuted, setSearchExecuted] = useState(false); // 검색 실행 여부 추적
  const [highlightedMarker, setHighlightedMarker] = useState(null);
  const [searchMapName, setSearchMapName] = useState('all'); // 검색할 지도 선택

  // 건물 오버레이 상태
  const [hoveredBuilding, setHoveredBuilding] = useState(null);
  const [buildingsVisible, setBuildingsVisible] = useState(true); // 건물 표시 토글
  
  // 클릭 위치 추적 (거리 계산 방지용)
  const [mouseDownPosition, setMouseDownPosition] = useState(null);

  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    setCrosshair({
      show: true,
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      pageX: e.pageX,
      pageY: e.pageY,
    });
    if (drag.dragging) {
      setOffset({
        x: drag.originX + (e.clientX - drag.startX),
        y: drag.originY + (e.clientY - drag.startY),
      });
    }
  };

  const handleMouseLeave = () => {
    setCrosshair((prev) => ({ ...prev, show: false }));
  };

  // 이미지 영역에서만 wheel 이벤트로 페이지 스크롤 방지
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const handleWheel = (e) => {
      e.preventDefault();
    };
    container.addEventListener("wheel", handleWheel, { passive: false });
    return () => {
      container.removeEventListener("wheel", handleWheel);
    };
  }, []);

  // 창 크기 변경 감지 및 오버레이 재조정
  useEffect(() => {
    const handleResize = () => {
      // 오버레이 리렌더링을 위한 키 업데이트
      setOverlayKey(prev => prev + 1);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // 좌표 검색 모달 스크롤 방지
  useEffect(() => {
    if (coordSearchModalOpen) {
      // 모달이 열렸을 때 body 스크롤 방지
      document.body.style.overflow = 'hidden';
    } else {
      // 모달이 닫혔을 때 body 스크롤 복원
      document.body.style.overflow = 'unset';
    }

    // 컴포넌트 언마운트 시 스크롤 복원
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [coordSearchModalOpen]);

  // 이미지 크기 변화 감지 (ResizeObserver 사용)
  useEffect(() => {
    const imgElement = imgRef.current;
    if (!imgElement) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setImgSize({ width, height });
        setOverlayKey(prev => prev + 1); // 오버레이 재조정
      }
    });

    resizeObserver.observe(imgElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [selectedMap]); // selectedMap이 변경될 때마다 observer 재설정

  // 확대/축소
  const handleWheel = React.useCallback((e) => {
    e.preventDefault();
    let newZoom = zoom - e.deltaY * 0.01;
    newZoom = Math.max(1, Math.min(5, newZoom)); // 1~5배 제한

    // zoom이 1로 돌아가면 offset을 0,0으로 리셋
    if (newZoom === 1) {
      setZoom(1);
      setOffset({ x: 0, y: 0 });
      return;
    }

    setZoom(newZoom);

    // 마우스 위치 기준으로 offset 조정 (줌인/줌아웃 시 중심 유지)
    if (imgSize.width && imgSize.height) {
      const rect = containerRef.current.getBoundingClientRect();
      const mouseX = e.clientX - rect.left - offset.x;
      const mouseY = e.clientY - rect.top - offset.y;
      const ratio = newZoom / zoom;
      setOffset({
        x: offset.x - mouseX * (ratio - 1),
        y: offset.y - mouseY * (ratio - 1),
      });
    }
  }, [zoom, offset, imgSize.width, imgSize.height]);

  // 이미지 영역에서만 wheel 이벤트로 페이지 스크롤 방지 및 확대/축소 동작
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    const wheelListener = (e) => handleWheel(e);
    container.addEventListener("wheel", wheelListener, { passive: false });
    return () => {
      container.removeEventListener("wheel", wheelListener);
    };
  }, [zoom, offset, imgSize.width, imgSize.height, handleWheel]);

  // 드래그 시작
  const handleMouseDown = (e) => {
    // 마우스 다운 위치 저장 (거리 계산 방지용)
    setMouseDownPosition({ x: e.clientX, y: e.clientY });
    
    if (zoom === 1) return;
    setDrag({
      dragging: true,
      startX: e.clientX,
      startY: e.clientY,
      originX: offset.x,
      originY: offset.y,
    });
  };

  // 드래그 끝
  const handleMouseUp = () => {
    setDrag((prev) => ({ ...prev, dragging: false }));
  };

  // 지도 변경 시 확대/이동 초기화 및 URL 업데이트
  const handleSelectChange = (e) => {
    const newMap = e.target.value;
    setSelectedMap(newMap);
    setZoom(1);
    setOffset({ x: 0, y: 0 });
    
    // URL 파라미터 업데이트 (확장자 제거)
    const mapBaseName = newMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
    setSearchParams({ map: mapBaseName });
  };

  // URL 파라미터 변경 감지하여 지도 업데이트
  useEffect(() => {
    const mapParam = searchParams.get('map');
    if (mapParam) {
      const mapByFile = MAP_LIST.find(m => m.file === mapParam || m.file === `${mapParam}.webp`);
      const mapByName = MAP_LIST.find(m => m.name === mapParam);
      const targetMap = mapByFile || mapByName;
      
      if (targetMap && targetMap.file !== selectedMap) {
        setSelectedMap(targetMap.file);
        setZoom(1);
        setOffset({ x: 0, y: 0 });
      }
    }
  }, [searchParams, selectedMap]);

  // 오버레이 이미지 확인 및 상태 업데이트 (하드코딩된 매핑 사용)
  useEffect(() => {
    const mapBaseName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
    
    // 하드코딩된 지도별 오버레이 매핑
    const overlayMappings = {
      'mosquito_lake_l': ['mud', 'shell', 'weed'],
      'american_pond_l': [],
      'winding_rivulet_l': [],
      'old_burg_lake_l': ['mud', 'weed'],
      'belaya_river_l': [],
      'kuori_lake_l': [],
      'bear_lake_l': ['mud', 'shell', 'weed'],
      'volkhov_river_l': ['mud', 'pebble', 'sand-pebble', 'shell'],
      'seversky_donets_river_l': ['mud', 'pebble', 'sand-pebble', 'shell'],
      'sura_river_l': [],
      'ladoga_lake_l': [],
      'the_amber_lake_l': ['bridge', 'mud', 'sand-pebble', 'sand', 'shell', 'weed'],
      'ladoga_archipelago_l': [],
      'akhtuba_river_l': ['mud', 'sand-pebble', 'sand', 'shell', 'weed'],
      'copper_lake_l': ['mud', 'sand-pebble', 'sand', 'shell', 'weed'],
      'lower_tunguska_river_l': ['blocked', 'sand-pebble'],
      'yama_river_l': ['mud', 'sand-pebble'],
      'norwegian_sea_l': []
    };

    const available = overlayMappings[mapBaseName] || [];
    setAvailableOverlays(available);
    
    // 기본 활성화할 오버레이 설정 (blocked, bridge)
    const defaultActiveOverlays = new Set();
    if (available.includes('blocked')) {
      defaultActiveOverlays.add('blocked');
    }
    if (available.includes('bridge')) {
      defaultActiveOverlays.add('bridge');
    }
    setActiveOverlays(defaultActiveOverlays);
  }, [selectedMap]);

  // 오버레이 토글 핸들러
  const toggleOverlay = (overlayType) => {
    setActiveOverlays(prev => {
      const newSet = new Set(prev);
      if (newSet.has(overlayType)) {
        newSet.delete(overlayType);
      } else {
        newSet.add(overlayType);
      }
      return newSet;
    });
  };

  // 오버레이 타입별 한국어 이름
  const getOverlayName = (type) => {
    const names = {
      'mud': '진흙',
      'sand': '모래',
      'sand-pebble': '모래자갈',
      'shell': '조개껍질',
      'weed': '잡초',
      'pebble': '자갈',
      'blocked': '막힌곳',
      'bridge': '다리'
    };
    return names[type] || type;
  };

  // 오버레이 타입별 색상
  const getOverlayColor = (type) => {
    const colors = {
      'mud': '#663366',
      'sand': '#cccc66',
      'sand-pebble': '#33cccc',
      'shell': '#cccccc',
      'weed': '#009900',
      'pebble': '#0000ff',
      'blocked': '#ff3333',
      'bridge': '#000000'
    };
    return colors[type] || '#999999';
  };

  // 지도 변경 시 저장된 좌표 불러오기
  useEffect(() => {
    let isMounted = true;
    if (isAuthenticated()) {
      const loadData = async () => {
        try {
          const mapName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
          const userId = selectedUserId || user.id; // 선택된 유저 ID 또는 자신의 ID
          const response = await fetch(`/api/map-locations/${mapName}?userId=${userId}`, {
            headers: getAuthHeaders()
          });

          if (response.ok) {
            const locations = await response.json();
            setSavedLocations(prev => {
              // 이전과 다를 때만 토스트
              if (isMounted && (prev.length !== locations.length || JSON.stringify(prev) !== JSON.stringify(locations))) {
                const mapObj = MAP_LIST.find(m => m.file === selectedMap);
                const targetUser = selectedUserId ? userList.find(u => u.id === parseInt(selectedUserId)) : null;
                const userInfo = targetUser ? `[${targetUser.username}]` : '';
                const message = `${userInfo}[${mapObj ? mapObj.name : selectedMap}] 좌표 ${locations.length}개 로드 완료!`;
                
                // 자신의 좌표면 success, 다른 사람의 좌표면 info
                if (targetUser) {
                  info(message);
                } else {
                  success(message);
                }
              }
              return locations;
            });
          }
        } catch (error) {
          console.error('좌표 불러오기 오류:', error);
          showError('좌표 불러오기 오류: ' + (error?.message || '알 수 없는 오류'));
        }
      };
      loadData();
    } else {
      setSavedLocations([]);
    }
    return () => { isMounted = false; };
  }, [selectedMap, selectedUserId, isAuthenticated, getAuthHeaders, success, showError, info, user, userList]);

  // 관리자인 경우 유저 리스트 불러오기
  useEffect(() => {
    if (isAuthenticated() && isAdminVerified) {
      const loadUserList = async () => {
        try {
          const response = await fetch('/api/admin/users', {
            headers: getAuthHeaders()
          });

          if (response.ok) {
            const users = await response.json();
            setUserList(users);
          }
        } catch (error) {
          console.error('유저 리스트 불러오기 오류:', error);
          showError('유저 리스트를 불러올 수 없습니다.');
        }
      };
      loadUserList();
    }
  }, [isAuthenticated, user, getAuthHeaders, showError, isAdminVerified]);

  // 관리자인 경우 선택된 맵의 유저별 좌표 개수 불러오기
  useEffect(() => {
    if (isAuthenticated() && isAdminVerified && selectedMap) {
      const loadLocationCounts = async () => {
        try {
          const mapName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
          const response = await fetch(`/api/map-locations-count/${mapName}`, {
            headers: getAuthHeaders()
          });

          if (response.ok) {
            const counts = await response.json();
            setUserLocationCounts(counts);
          }
        } catch (error) {
          console.error('좌표 개수 불러오기 오류:', error);
        }
      };
      loadLocationCounts();
    }
  }, [isAuthenticated, user, selectedMap, getAuthHeaders, isAdminVerified]);

  // 현재 선택된 맵 정보
  const mapInfo = MAP_LIST.find((m) => m.file === selectedMap);

  // 좌표 변환 함수
  let coordText = "";
  let imgX = 0, imgY = 0;
  if (crosshair.show && imgSize.width && imgSize.height) {
    // 확대/이동을 반영한 실제 이미지 내 좌표 계산
    imgX = (crosshair.x - offset.x) / zoom;
    imgY = (crosshair.y - offset.y) / zoom;

    // 이미지 영역 밖이면 좌표 표시 안 함
    if (
      imgX >= 0 && imgX <= imgSize.width &&
      imgY >= 0 && imgY <= imgSize.height
    ) {
      const relX = Math.max(0, Math.min(1, imgX / imgSize.width));
      const relY = Math.max(0, Math.min(1, imgY / imgSize.height));
      // X: minX~maxX, Y: minY~maxY (Y는 위로 갈수록 커지게)
      const xVal = (mapInfo.max[0] - mapInfo.min[0]) * relX + mapInfo.min[0];
      const yVal = (mapInfo.max[1] - mapInfo.min[1]) * (1 - relY) + mapInfo.min[1];
      coordText = `${Math.floor(xVal)}, ${Math.floor(yVal)}`;
    } else {
      coordText = "";
    }
  }

  // 이미지 클릭 시 선 그리기용 좌표 저장
  const handleMapClick = (e) => {
    if (!imgSize.width || !imgSize.height) return;

    // 마우스 다운 위치와 업 위치 비교 (5px 이상 차이나면 드래그로 간주)
    if (mouseDownPosition) {
      const deltaX = Math.abs(e.clientX - mouseDownPosition.x);
      const deltaY = Math.abs(e.clientY - mouseDownPosition.y);
      
      if (deltaX > 5 || deltaY > 5) {
        // 드래그로 간주하여 거리 계산 하지 않음
        setMouseDownPosition(null);
        return;
      }
    }
    
    // 마우스 위치 초기화
    setMouseDownPosition(null);

    // 검색된 점이 있으면 지우기
    if (searchedPoint) {
      setSearchedPoint(null);
      return;
    }

    // 3번째 클릭이면 모두 초기화
    if (clickCount === 2) {
      setLinePoints([]);
      setDistance(null);
      setClickCount(0);
      return;
    }

    const rect = containerRef.current.getBoundingClientRect();
    // 확대/이동 반영한 이미지 내 좌표
    const x = (e.clientX - rect.left - offset.x) / zoom;
    const y = (e.clientY - rect.top - offset.y) / zoom;
    if (x < 0 || x > imgSize.width || y < 0 || y > imgSize.height) return;

    // 지도 좌표계로 변환
    const relX = Math.max(0, Math.min(1, x / imgSize.width));
    const relY = Math.max(0, Math.min(1, y / imgSize.height));
    const coordX = (mapInfo.max[0] - mapInfo.min[0]) * relX + mapInfo.min[0];
    const coordY = (mapInfo.max[1] - mapInfo.min[1]) * (1 - relY) + mapInfo.min[1];

    if (clickCount === 0) {
      setLinePoints([{ imgX: x, imgY: y, coordX: coordX, coordY: coordY }]);
      setDistance(null);
      setClickCount(1);
    } else if (clickCount === 1) {
      const pt1 = linePoints[0];
      const pt2 = { imgX: x, imgY: y, coordX: coordX, coordY: coordY };
      setLinePoints([pt1, pt2]);
      // 거리 계산 (유클리드 거리, 지도 좌표계, 실수값 기준)
      const dx = Math.abs(pt2.coordX - pt1.coordX);
      const dy = Math.abs(pt2.coordY - pt1.coordY);
      const distCoord = Math.sqrt(dx * dx + dy * dy);
      setDistance(distCoord * (mapInfo.distancePerCoord || 1));
      setClickCount(2);
    }
  };

  // 우클릭 이벤트 핸들러 (좌표 기록)
  const handleRightClick = (e) => {
    e.preventDefault();
    
    // 로그인 상태가 아니면 무시
    if (!isAuthenticated()) {
      showError('좌표 저장은 로그인 후 이용하실 수 있습니다.');
      return;
    }

    // 관리자가 다른 유저의 좌표를 보고 있는 경우 차단
    if (isAdminVerified && selectedUserId) {
      warning('다른 유저의 좌표를 보고 있을 때는 좌표를 생성할 수 없습니다.');
      return;
    }

    if (!imgSize.width || !imgSize.height) return;

    const rect = containerRef.current.getBoundingClientRect();
    // 확대/이동 반영한 이미지 내 좌표
    const x = (e.clientX - rect.left - offset.x) / zoom;
    const y = (e.clientY - rect.top - offset.y) / zoom;
    
    // 이미지 영역 밖이면 무시
    if (x < 0 || x > imgSize.width || y < 0 || y > imgSize.height) return;

    // 지도 좌표계로 변환
    const relX = Math.max(0, Math.min(1, x / imgSize.width));
    const relY = Math.max(0, Math.min(1, y / imgSize.height));
    const coordX = (mapInfo.max[0] - mapInfo.min[0]) * relX + mapInfo.min[0];
    const coordY = (mapInfo.max[1] - mapInfo.min[1]) * (1 - relY) + mapInfo.min[1];

    // 모달에 좌표 설정
    setModalCoord({ x: Math.round(coordX * 100) / 100, y: Math.round(coordY * 100) / 100 });
    setShowLocationModal(true);
  };

  // 좌표 저장 함수
  const saveLocation = async () => {
    try {
      const response = await fetch('/api/map-locations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({
          mapName: selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, ''),
          coordX: modalCoord.x,
          coordY: modalCoord.y,
          type: locationForm.type,
          fish: locationForm.fish,
          bait: locationForm.bait,
          memo: locationForm.memo
        })
      });

      if (response.ok) {
        // 성공 시 저장된 좌표 목록 다시 불러오기
        loadSavedLocations();
        setShowLocationModal(false);
        setLocationForm({
          type: 'float',
          fish: '',
          bait: '',
          memo: ''
        });
        // 토스트 메시지
        const mapObj = MAP_LIST.find(m => m.file === selectedMap);
        success(`[${mapObj ? mapObj.name : selectedMap}] (${modalCoord.x.toFixed(2)}, ${modalCoord.y.toFixed(2)}) 좌표 저장 완료!`);
      } else {
        const errorData = await response.json();
        showError('저장 실패: ' + (errorData.error || '알 수 없는 오류'));
      }
    } catch (error) {
      console.error('좌표 저장 오류:', error);
  showError('네트워크 오류로 저장에 실패했습니다.');
    }
  };

  // 저장된 좌표 불러오기
  const loadSavedLocations = async () => {
    if (!isAuthenticated()) return;

    try {
      // 파일 확장자를 제거한 맵 이름 사용
      const mapName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
      const userId = selectedUserId || user.id; // 선택된 유저 ID 또는 자신의 ID
      const response = await fetch(`/api/map-locations/${mapName}?userId=${userId}`, {
        headers: getAuthHeaders()
      });

      if (response.ok) {
        const locations = await response.json();
        setSavedLocations(locations);
        // 토스트 메시지
        const mapObj = MAP_LIST.find(m => m.file === selectedMap);
        const targetUser = selectedUserId ? userList.find(u => u.id === parseInt(selectedUserId)) : null;
        const userInfo = targetUser ? `[${targetUser.username}]` : '';
        const message = `${userInfo}[${mapObj ? mapObj.name : selectedMap}] 좌표 ${locations.length}개 로드 완료!`;
        
        // 자신의 좌표면 success, 다른 사람의 좌표면 info
        if (targetUser) {
          info(message);
        } else {
          success(message);
        }
      }
    } catch (error) {
      console.error('좌표 불러오기 오류:', error);
    }
  };

  // 마커 우클릭 핸들러
  const handleMarkerRightClick = (e, location) => {
    e.preventDefault();
    e.stopPropagation();
    
    // 관리자가 다른 유저의 좌표를 보고 있는 경우 차단
    if (isAdminVerified && selectedUserId) {
      warning('다른 유저의 좌표를 보고 있을 때는 좌표를 수정할 수 없습니다.');
      return;
    }
    
    setEditingLocation(location);
    setEditForm({
      type: location.type,
      fish: location.fish || '',
      bait: location.bait || '',
      memo: location.memo || ''
    });
    setShowEditModal(true);
  };

  // 좌표 수정 함수
  const updateLocation = async () => {
    if (!editingLocation) return;

    try {
      const response = await fetch(`/api/map-locations/${editingLocation.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({
          type: editForm.type,
          fish: editForm.fish,
          bait: editForm.bait,
          memo: editForm.memo
        })
      });

      if (response.ok) {
        loadSavedLocations();
        setShowEditModal(false);
        setEditingLocation(null);
      } else {
        const errorData = await response.json();
    showError('수정 실패: ' + (errorData.error || '알 수 없는 오류'));
      }
    } catch (error) {
      console.error('좌표 수정 오류:', error);
      showError('네트워크 오류로 수정에 실패했습니다.');
    }
  };

  // 좌표 삭제 함수
  const deleteLocation = async () => {
    if (!editingLocation) return;
    
    setShowDeleteModal(true);
  };

  // 삭제 확인 함수
  const confirmDelete = async () => {
    if (!editingLocation) return;

    try {
      const response = await fetch(`/api/map-locations/${editingLocation.id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });

      if (response.ok) {
        loadSavedLocations();
        setShowEditModal(false);
        setShowDeleteModal(false);
        setEditingLocation(null);
      } else {
        const errorData = await response.json();
    showError('삭제 실패: ' + (errorData.error || '알 수 없는 오류'));
      }
    } catch (error) {
      console.error('좌표 삭제 오류:', error);
      showError('네트워크 오류로 삭제에 실패했습니다.');
    }
  };

  // 지도 변경 시 선/거리/클릭수 초기화
  useEffect(() => {
    setLinePoints([]);
    setDistance(null);
    setClickCount(0);
  }, [selectedMap]);

  // 좌표 검색 핸들러
  const handleSearch = () => {
    if (!imgSize.width || !imgSize.height) return;
    const xVal = parseFloat(searchX);
    const yVal = parseFloat(searchY);
    if (isNaN(xVal) || isNaN(yVal)) return;

    // 지도 좌표계 → 이미지 상대좌표 (0~1)
    const relX = (xVal - mapInfo.min[0]) / (mapInfo.max[0] - mapInfo.min[0]);
    const relY = (mapInfo.max[1] - yVal) / (mapInfo.max[1] - mapInfo.min[1]);
    // 이미지 내 픽셀 좌표
    const imgX = relX * imgSize.width;
    const imgY = relY * imgSize.height;

    setSearchedPoint({ imgX, imgY });
  };

  // 지도 변경 시 검색 점도 초기화
  useEffect(() => {
    setSearchedPoint(null);
  }, [selectedMap]);

  // 데이터 파싱 함수
  const parseCoordData = (coordData) => {
    const entries = coordData.split(';').filter(entry => entry.trim());
    const parsed = [];

    for (const entry of entries) {
      const parts = entry.split(':');
      if (parts.length < 8) continue;

      const type = parts[0].trim();
      const coordX = parseFloat(parts[3]);
      const coordY = parseFloat(parts[4]);
      const fish = parts[5] ? parts[5].trim() : '';
      const bait = parts[6] ? parts[6].trim() : '';
      const memo = parts[7] ? parts[7].trim() : '';

      // 타입 변환
      let fishingType;
      let typeText;
      switch (type) {
        case '1':
          fishingType = 'float';
          typeText = '찌낚시';
          break;
        case '2':
          fishingType = 'bottom';
          typeText = '바텀낚시';
          break;
        case '3':
          fishingType = 'lure';
          typeText = '루어낚시';
          break;
        default:
          continue;
      }

      if (!isNaN(coordX) && !isNaN(coordY)) {
        parsed.push({
          type: fishingType,
          typeText,
          coordX,
          coordY,
          fish,
          bait,
          memo
        });
      }
    }

    return parsed;
  };

  // 데이터 미리보기 함수
  const handlePreviewData = () => {
    if (!importForm.coordData.trim()) {
      showError('좌표 데이터를 입력해주세요.');
      return;
    }

    const parsed = parseCoordData(importForm.coordData);
    if (parsed.length === 0) {
      showError('유효한 좌표 데이터가 없습니다.');
      return;
    }

    setParsedData(parsed);
    setShowPreview(true);
    success(`${parsed.length}개의 좌표 데이터를 파싱했습니다.`);
  };

  // 데이터 임포트 함수
  const handleImportData = async () => {
    if (!importForm.mapName) {
      showError('지도를 선택해주세요.');
      return;
    }

    if (parsedData.length === 0) {
      showError('먼저 데이터를 미리보기해주세요.');
      return;
    }

    try {
      const response = await fetch('/api/map-locations/bulk-import', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...getAuthHeaders()
        },
        body: JSON.stringify({
          mapName: importForm.mapName,
          coordData: importForm.coordData
        })
      });

      if (response.ok) {
        const result = await response.json();
        success(`${result.importedCount}개의 좌표가 성공적으로 임포트되었습니다.`);
        
        // 모달 닫기 및 초기화
        setShowImportModal(false);
        setImportForm({ mapName: '', coordData: '' });
        setParsedData([]);
        setShowPreview(false);
        
        // 현재 지도가 임포트한 지도와 같으면 새로고침
        if (selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '') === importForm.mapName) {
          loadSavedLocations();
        }
      } else {
        const errorData = await response.json();
        showError('임포트 실패: ' + (errorData.error || '알 수 없는 오류'));
      }
    } catch (error) {
      console.error('임포트 오류:', error);
      showError('네트워크 오류가 발생했습니다.');
    }
  };

  // 영문 파일명을 한글 지도명으로 변환하는 함수
  const getKoreanMapName = (englishFileName) => {
    const mapItem = MAP_LIST.find(map => map.file.replace(/\.(webp|jpg|jpeg|png)$/i, '') === englishFileName);
    return mapItem ? mapItem.name : englishFileName;
  };

  // 좌표 검색 함수
  const searchCoordinates = async () => {
    if (!searchTerm.trim()) {
      setSearchResults([]);
      setSearchExecuted(false);
      return;
    }

    setSearchLoading(true);
    setSearchExecuted(true);
    try {
      const response = await fetch(`/api/map-locations-search?mapName=${encodeURIComponent(searchMapName)}&searchTerm=${encodeURIComponent(searchTerm.trim())}`, {
        method: 'GET',
        headers: {
          ...getAuthHeaders()
        }
      });

      if (response.ok) {
        const results = await response.json();
        setSearchResults(results);
      } else {
        const errorData = await response.json();
        showError(errorData.error || '검색에 실패했습니다.');
        setSearchResults([]);
      }
    } catch (error) {
      console.error('Search error:', error);
      showError('검색 중 네트워크 오류가 발생했습니다.');
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  // 검색 결과 좌표를 클릭했을 때 처리
  const handleSearchResultClick = (result) => {
    // 해당 지도로 변경 (result.map_name은 영어 파일명)
    const targetMapFile = result.map_name + '.webp';
    const targetMap = MAP_LIST.find(map => map.file === targetMapFile);
    if (targetMap && targetMap.file !== selectedMap) {
      setSelectedMap(targetMap.file);
      // URL 파라미터 업데이트
      setSearchParams({ map: result.map_name });
    }

    // 마커 강조 표시
    setHighlightedMarker(result.id);
    
    // 검색 모달 닫기
    setCoordSearchModalOpen(false);

    // 3초 후 강조 해제
    setTimeout(() => {
      setHighlightedMarker(null);
    }, 3000);
  };

  return (
    <>
    <div className="interactive-maps-layout">
      {/* sidebar는 한 번만 렌더링 */}
      <div className="interactive-maps-sidebar">
        <div className="interactive-maps-sidebar-inner">
          <h1 className="page-title">반응형 지도</h1>
          <div style={{ display: 'flex', gap: '5px', marginTop: '10px', width: '100%' }}>
            <button 
              type="button" 
              onClick={() => setShowHelpModal(true)} 
              className="interactive-maps-btn interactive-maps-help-btn"
              style={{ flex: 1 }}
            >
              📖 사용법
            </button>
            <button 
              type="button" 
              onClick={() => {
                if (!isAuthenticated()) {
                  showError('데이터 가져오기는 로그인 후 이용하실 수 있습니다.');
                  return;
                }
                setShowImportModal(true);
              }} 
              className="interactive-maps-btn"
              style={{ flex: 1, backgroundColor: '#28a745', borderColor: '#28a745' }}
            >
              📋 가져오기
            </button>
          </div>

          {/* 좌표 검색 버튼 */}
          <button
            type="button"
            className="interactive-maps-btn"
            onClick={() => {
              // 로그인 체크
              if (!isAuthenticated()) {
                showError('좌표 검색은 로그인 후 이용하실 수 있습니다.');
                return;
              }
              
              // 검색 기본값을 전체로 설정
              setSearchMapName('all');
              // 검색 결과 초기화
              setSearchResults([]);
              setSearchTerm('');
              setSearchExecuted(false);
              setCoordSearchModalOpen(true);
            }}
            style={{
              width: '100%',
              backgroundColor: '#28a745',
              borderColor: '#28a745'
            }}
            title="내 좌표 검색"
          >
            🔍 저장된 좌표 검색
          </button>
          
          <select
            value={selectedMap}
            onChange={handleSelectChange}
            className="interactive-maps-select"
          >
            {MAP_LIST.map((map) => (
              <option key={map.file} value={map.file}>
                {map.name}
              </option>
            ))}
          </select>
          <div className="interactive-maps-search">
            <input
              type="number"
              placeholder="X 좌표"
              value={searchX}
              onChange={e => setSearchX(e.target.value)}
              className="interactive-maps-input"
              min={mapInfo ? Math.min(mapInfo.min[0], mapInfo.max[0]) : undefined}
              max={mapInfo ? Math.max(mapInfo.min[0], mapInfo.max[0]) : undefined}
            />
            <input
              type="number"
              placeholder="Y 좌표"
              value={searchY}
              onChange={e => setSearchY(e.target.value)}
              className="interactive-maps-input"
              min={mapInfo ? Math.min(mapInfo.min[1], mapInfo.max[1]) : undefined}
              max={mapInfo ? Math.max(mapInfo.min[1], mapInfo.max[1]) : undefined}
            />
            <button type="button" onClick={handleSearch} className="interactive-maps-btn">
              검색
            </button>
          </div>
          
          {/* 오버레이 토글 스위치 */}
          {availableOverlays.length > 0 && (
            <div className="interactive-maps-overlay-section">
              <h4 className="overlay-section-title">지형 오버레이</h4>
              <div className="overlay-toggles">
                {availableOverlays.map((overlayType) => (
                  <div key={overlayType} className="overlay-toggle-item">
                    <label className="overlay-toggle-label">
                      <input
                        type="checkbox"
                        checked={activeOverlays.has(overlayType)}
                        onChange={() => toggleOverlay(overlayType)}
                        className="overlay-toggle-checkbox"
                      />
                      <span className="overlay-toggle-slider"></span>
                      <svg width="12" height="12" style={{ margin: '0 4px' }}>
                        <rect 
                          width="12" 
                          height="12" 
                          fill={getOverlayColor(overlayType)}
                          stroke="#333"
                          strokeWidth="0.5"
                        />
                      </svg>
                      <span className="overlay-toggle-text">{getOverlayName(overlayType)}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {/* 건물 오버레이 토글 */}
          {(() => {
            const mapBaseName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
            const hasBuildings = BUILDING_DATA[mapBaseName] && BUILDING_DATA[mapBaseName].length > 0;
            return hasBuildings && (
              <div className="interactive-maps-overlay-section" style={{ marginTop: '10px' }}>
                <h4 className="overlay-section-title">건물 / 랜드마크</h4>
                <div className="overlay-toggles">
                  <div className="overlay-toggle-item">
                    <label className="overlay-toggle-label">
                      <input
                        type="checkbox"
                        checked={buildingsVisible}
                        onChange={() => setBuildingsVisible(!buildingsVisible)}
                        className="overlay-toggle-checkbox"
                      />
                      <span className="overlay-toggle-slider"></span>
                      <span style={{ margin: '0 4px', fontSize: '16px' }}>🏠</span>
                      <span className="overlay-toggle-text">
                        건물 표시 ({BUILDING_DATA[mapBaseName].length}개)
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            );
          })()}
          
          {/* 관리자 권한인 유저에게만 보이며 유저별로 필터링 하여 해당 유저 좌표 리스트를 불러오는 기능 */}
          {isAdminVerified && (
            <div className="interactive-maps-admin-section">
              <label htmlFor="user-select" style={{ 
                display: 'block', 
                marginBottom: '5px', 
                fontSize: '14px', 
                fontWeight: 'bold',
                color: '#ff6b6b'
              }}>
                👑 관리자: 유저 선택
              </label>
              <select
                id="user-select"
                value={selectedUserId}
                onChange={(e) => setSelectedUserId(e.target.value)}
                className="interactive-maps-select"
                style={{ marginBottom: '10px' }}
              >
                <option value="">선택없음 (내 좌표)</option>
                {userList
                  .sort((a, b) => (userLocationCounts[b.id] || 0) - (userLocationCounts[a.id] || 0))
                  .map((userItem) => (
                    <option key={userItem.id} value={userItem.id}>
                      {userItem.username} ({userLocationCounts[userItem.id] || 0}개)
                    </option>
                  ))}
              </select>
              {selectedUserId && (
                <div style={{
                  fontSize: '12px',
                  color: '#666',
                  marginTop: '5px',
                  padding: '5px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  border: '1px solid #e9ecef'
                }}>
                  ℹ️ 다른 유저의 좌표를 확인 중입니다. 수정/삭제는 불가능합니다.
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        ref={containerRef}
        className="interactive-maps-mapwrap"
        onMouseMove={handleMouseMove}
        onMouseLeave={(e) => { handleMouseLeave(e); setDrag((prev) => ({ ...prev, dragging: false })); }}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onClick={handleMapClick}
        onContextMenu={handleRightClick}
        onDragStart={(e) => e.preventDefault()}
      >
        <img
          ref={imgRef}
          src={MAP_BASE_PATH + selectedMap}
          alt="지도"
          className="interactive-maps-img"
          onLoad={e => {
            setImgSize({ width: e.target.width, height: e.target.height });
            // 이미지 크기 변경 시 오버레이도 재조정
            setOverlayKey(prev => prev + 1);
          }}
          draggable={false}
          onDragStart={(e) => e.preventDefault()}
          style={{
            transform: `scale(${zoom}) translate(${offset.x / zoom}px, ${offset.y / zoom}px)`,
            transformOrigin: "top left",
            userSelect: "none",
            pointerEvents: "none",
            cursor: crosshair.show && zoom === 1 ? "crosshair" : undefined,
          }}
        />
        
        {/* 오버레이 이미지들 */}
        {activeOverlays.size > 0 && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: imgSize.width,
              height: imgSize.height,
              transform: `scale(${zoom}) translate(${offset.x / zoom}px, ${offset.y / zoom}px)`,
              transformOrigin: "top left",
              pointerEvents: "none",
              zIndex: 5,
            }}
          >
            {availableOverlays.map((overlayType) => {
              if (!activeOverlays.has(overlayType)) return null;
              
              const mapBaseName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
              const overlayPath = `/data/maps/map-overlay/${mapBaseName}-${overlayType}.webp`;
              
              return (
                <img
                  key={`${overlayType}-${overlayKey}`}
                  src={overlayPath}
                  alt={`${getOverlayName(overlayType)} 오버레이`}
                  className="interactive-maps-overlay"
                  draggable={false}
                  onDragStart={(e) => e.preventDefault()}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: imgSize.width,
                    height: imgSize.height,
                    userSelect: "none",
                    pointerEvents: "none",
                    opacity: 0.7,
                  }}
                />
              );
            })}
          </div>
        )}
        
        {/* 건물 오버레이 */}
        {buildingsVisible && imgSize.width > 0 && imgSize.height > 0 && mapInfo && (() => {
          const mapBaseName = selectedMap.replace(/\.(webp|jpg|jpeg|png)$/i, '');
          const buildings = BUILDING_DATA[mapBaseName] || [];
          
          return buildings.map((building, index) => {
            // 게임 좌표를 이미지 픽셀 좌표로 변환
            const coordToPixel = (coordX, coordY) => {
              const relX = (coordX - mapInfo.min[0]) / (mapInfo.max[0] - mapInfo.min[0]);
              const relY = (mapInfo.max[1] - coordY) / (mapInfo.max[1] - mapInfo.min[1]);
              return {
                x: relX * imgSize.width,
                y: relY * imgSize.height
              };
            };
            
            const topLeft = coordToPixel(building.coords[0], building.coords[3]);
            const bottomRight = coordToPixel(building.coords[2], building.coords[1]);
            
            const width = Math.abs(bottomRight.x - topLeft.x);
            const height = Math.abs(bottomRight.y - topLeft.y);
            const centerX = (topLeft.x + bottomRight.x) / 2;
            const centerY = (topLeft.y + bottomRight.y) / 2;
            
            // 회전 중심점 (중심 또는 custom)
            const rotationCenter = building.center 
              ? coordToPixel(building.center[0], building.center[1])
              : { x: centerX, y: centerY };
            
            // zoom과 offset을 적용한 화면 좌표 계산
            const screenLeft = topLeft.x * zoom + offset.x;
            const screenTop = topLeft.y * zoom + offset.y;
            const screenWidth = width * zoom;
            const screenHeight = height * zoom;
            
            return (
              <div
                key={`building-${index}`}
                style={{
                  position: 'absolute',
                  left: screenLeft,
                  top: screenTop,
                  width: screenWidth,
                  height: screenHeight,
                  transform: `rotate(${building.rotation || 0}deg)`,
                  transformOrigin: `${(rotationCenter.x - topLeft.x) * zoom}px ${(rotationCenter.y - topLeft.y) * zoom}px`,
                  border: '2px solid rgba(255, 165, 0, 0.8)',
                  backgroundColor: 'rgba(255, 165, 0, 0.2)',
                  pointerEvents: 'auto',
                  cursor: 'pointer',
                  zIndex: 100,
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  setHoveredBuilding(building);
                }}
                onMouseLeave={(e) => {
                  e.stopPropagation();
                  setHoveredBuilding(null);
                }}
                onMouseMove={(e) => {
                  e.stopPropagation();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setHoveredBuilding(building);
                }}
              />
            );
          });
        })()}
        
        {/* 건물 툴팁 (독립 레이어) */}
        {buildingsVisible && hoveredBuilding && imgSize.width > 0 && imgSize.height > 0 && mapInfo && (() => {
          // hoveredBuilding의 화면 좌표 계산
          const coordToPixel = (coordX, coordY) => {
            const relX = (coordX - mapInfo.min[0]) / (mapInfo.max[0] - mapInfo.min[0]);
            const relY = (mapInfo.max[1] - coordY) / (mapInfo.max[1] - mapInfo.min[1]);
            return {
              x: relX * imgSize.width,
              y: relY * imgSize.height
            };
          };
          
          const topLeft = coordToPixel(hoveredBuilding.coords[0], hoveredBuilding.coords[3]);
          const bottomRight = coordToPixel(hoveredBuilding.coords[2], hoveredBuilding.coords[1]);
          const centerX = (topLeft.x + bottomRight.x) / 2;
          const centerY = (topLeft.y + bottomRight.y) / 2;
          
          const screenCenterX = centerX * zoom + offset.x;
          const screenCenterY = centerY * zoom + offset.y;
          
          return (
            <div
              style={{
                position: 'absolute',
                left: screenCenterX,
                top: screenCenterY - 20, // 건물 위쪽에 표시
                transform: 'translate(-50%, -100%)', // 중앙 정렬 및 위쪽 배치
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                color: 'white',
                padding: '8px 14px',
                borderRadius: '6px',
                whiteSpace: 'nowrap',
                fontSize: '14px',
                fontWeight: 'bold',
                pointerEvents: 'none',
                boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
                zIndex: 9999,
                border: '2px solid rgba(255, 165, 0, 0.8)',
              }}
            >
              🏠 {hoveredBuilding.name}
            </div>
          );
        })()}
        
        {/* 검색된 점 표시 */}
        {searchedPoint && (
          <svg
            className="interactive-maps-point-svg"
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: imgSize.width * zoom + offset.x,
              height: imgSize.height * zoom + offset.y,
              pointerEvents: "none",
              zIndex: 200,
            }}
          >
            <circle
              cx={searchedPoint.imgX * zoom + offset.x}
              cy={searchedPoint.imgY * zoom + offset.y}
              r="7"
              fill="orange"
              stroke="red"
              strokeWidth="3"
              style={{ pointerEvents: "none" }}
            />
          </svg>
        )}
        {/* 저장된 좌표들 표시 */}
        {savedLocations.length > 0 && (
          <svg
            className="interactive-maps-saved-locations-svg"
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: imgSize.width * zoom + offset.x,
              height: imgSize.height * zoom + offset.y,
              pointerEvents: "none",
              zIndex: 150,
            }}
          >
            {savedLocations.map((location, index) => {
              // 지도 좌표계를 이미지 좌표로 변환
              const relX = (location.coord_x - mapInfo.min[0]) / (mapInfo.max[0] - mapInfo.min[0]);
              const relY = (mapInfo.max[1] - location.coord_y) / (mapInfo.max[1] - mapInfo.min[1]);
              const imgX = relX * imgSize.width;
              const imgY = relY * imgSize.height;
              
              // 색상 결정
              const getColor = (type) => {
                switch(type) {
                  case 'float': return '#4CAF50'; // 초록색
                  case 'bottom': return '#2196F3'; // 파란색  
                  case 'lure': return '#FF9800'; // 주황색
                  default: return '#9C27B0'; // 보라색
                }
              };

              return (
                <g key={location.id}>
                  {/* 강조된 마커용 그래디언트 링 */}
                  {highlightedMarker === location.id && (
                    <>
                      <defs>
                        <radialGradient id={`highlightGradient-${location.id}`} cx="50%" cy="50%" r="50%">
                          <stop offset="0%" stopColor="#8b00ff" stopOpacity="0.9">
                            <animate attributeName="stop-color" values="#8b00ff;#4b0082;#6a0dad;#9932cc;#8b00ff" dur="2s" repeatCount="indefinite" />
                          </stop>
                          <stop offset="30%" stopColor="#ff1493" stopOpacity="0.7">
                            <animate attributeName="stop-color" values="#ff1493;#dc143c;#b22222;#ff69b4;#ff1493" dur="2s" repeatCount="indefinite" />
                          </stop>
                          <stop offset="70%" stopColor="#ffffff" stopOpacity="0.4">
                            <animate attributeName="stop-opacity" values="0.4;0.8;0.4" dur="2s" repeatCount="indefinite" />
                          </stop>
                          <stop offset="100%" stopColor="transparent" stopOpacity="0" />
                        </radialGradient>
                      </defs>
                      <circle
                        cx={imgX * zoom + offset.x}
                        cy={imgY * zoom + offset.y}
                        r="15"
                        fill={`url(#highlightGradient-${location.id})`}
                        style={{ 
                          cursor: "pointer",
                          transformOrigin: `${imgX * zoom + offset.x}px ${imgY * zoom + offset.y}px`
                        }}
                      >
                        <animateTransform
                          attributeName="transform"
                          type="scale"
                          values="1;1.5;1"
                          dur="2s"
                          repeatCount="indefinite"
                        />
                      </circle>
                    </>
                  )}
                  <circle
                    cx={imgX * zoom + offset.x}
                    cy={imgY * zoom + offset.y}
                    r="6"
                    fill={highlightedMarker === location.id ? '#8b00ff' : getColor(location.type)}
                    stroke={highlightedMarker === location.id ? '#ffffff' : 'white'}
                    strokeWidth={highlightedMarker === location.id ? '3' : '2'}
                    style={{ cursor: "pointer", pointerEvents: "auto" }}
                    onMouseEnter={() => setHoveredLocation(location)}
                    onMouseLeave={() => setHoveredLocation(null)}
                    onContextMenu={(e) => handleMarkerRightClick(e, location)}
                  />
                  <text
                    x={imgX * zoom + offset.x}
                    y={imgY * zoom + offset.y - 10}
                    textAnchor="middle"
                    fontSize="12"
                    fill="aqua"
                    fontWeight="bold"
                    style={{ pointerEvents: "none" }}
                  >
                    {Math.floor(location.coord_x)},{Math.floor(location.coord_y)}
                  </text>
                </g>
              );
            })}
          </svg>
        )}
        
        {/* 마커 툴팁 */}
        {hoveredLocation && (
          <div
            style={{
              position: "absolute",
              left: crosshair.x + 10,
              top: crosshair.y - 80,
              background: "#fff",
              color: "#333",
              border: "1px solid #ccc",
              borderRadius: "6px",
              padding: "8px 12px",
              fontSize: "12px",
              pointerEvents: "none",
              zIndex: 9999,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              whiteSpace: "pre-wrap",
              maxWidth: "200px",
            }}
          >
            <div><strong>유형:</strong> {
              hoveredLocation.type === 'float' ? '찌낚시' :
              hoveredLocation.type === 'bottom' ? '바텀' :
              hoveredLocation.type === 'lure' ? '루어' :
              hoveredLocation.type
            }</div>
            {hoveredLocation.fish && <div><strong>어종:</strong> {hoveredLocation.fish}</div>}
            {hoveredLocation.bait && <div><strong>미끼:</strong> {hoveredLocation.bait}</div>}
            {hoveredLocation.memo && (
              <div>
                <strong>메모:</strong>
                <div style={{ whiteSpace: "pre-wrap", marginTop: "2px" }}>
                  {hoveredLocation.memo}
                </div>
              </div>
            )}
            <div><strong>좌표:</strong> {parseFloat(hoveredLocation.coord_x).toFixed(2)}, {parseFloat(hoveredLocation.coord_y).toFixed(2)}</div>
          </div>
        )}
        {/* 선 그리기: 두 점 모두 선택된 경우 */}
        {linePoints.length === 2 && (
          <svg
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: imgSize.width * zoom + offset.x,
              height: imgSize.height * zoom + offset.y,
              pointerEvents: "none",
              zIndex: 10,
            }}
          >
            <line
              x1={linePoints[0].imgX * zoom + offset.x}
              y1={linePoints[0].imgY * zoom + offset.y}
              x2={linePoints[1].imgX * zoom + offset.x}
              y2={linePoints[1].imgY * zoom + offset.y}
              stroke="magenta"
              strokeWidth="3"
            />
            {/* 점 표시 */}
            <circle
              cx={linePoints[0].imgX * zoom + offset.x}
              cy={linePoints[0].imgY * zoom + offset.y}
              r="6"
              fill="cyan"
              stroke="black"
              strokeWidth="2"
            />
            <circle
              cx={linePoints[1].imgX * zoom + offset.x}
              cy={linePoints[1].imgY * zoom + offset.y}
              r="6"
              fill="cyan"
              stroke="black"
              strokeWidth="2"
            />
          </svg>
        )}
        {/* 선 그리기: 첫 번째 클릭 후 마우스 포인터까지 실시간 선 */}
        {linePoints.length === 1 && crosshair.show && (
          <svg
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: imgSize.width * zoom + offset.x,
              height: imgSize.height * zoom + offset.y,
              pointerEvents: "none",
              zIndex: 10,
            }}
          >
            <line
              x1={linePoints[0].imgX * zoom + offset.x}
              y1={linePoints[0].imgY * zoom + offset.y}
              x2={(crosshair.x - offset.x) / zoom * zoom + offset.x}
              y2={(crosshair.y - offset.y) / zoom * zoom + offset.y}
              stroke="magenta"
              strokeWidth="2"
              strokeDasharray="6 6"
            />
            <circle
              cx={linePoints[0].imgX * zoom + offset.x}
              cy={linePoints[0].imgY * zoom + offset.y}
              r="6"
              fill="cyan"
              stroke="black"
              strokeWidth="2"
            />
          </svg>
        )}
        {/* 거리 표시 */}
        {((linePoints.length === 2 && distance) || (linePoints.length === 1 && crosshair.show)) && (() => {
          let tooltipLeft, tooltipTop, tooltipOpacity = 1, tooltipDistance = null;
          if (linePoints.length === 2 && distance) {
            // 기존: 두 점 모두 선택된 경우
            tooltipLeft = ((linePoints[0].imgX + linePoints[1].imgX) / 2) * zoom + offset.x - 30;
            tooltipTop = ((linePoints[0].imgY + linePoints[1].imgY) / 2) * zoom + offset.y - 15;
            tooltipDistance = distance;
            tooltipOpacity = 1;
          } else if (linePoints.length === 1 && crosshair.show) {
            // 선을 그리는 중: 첫 점과 마우스 위치로 거리 계산
            const pt1 = linePoints[0];
            const imgX2 = (crosshair.x - offset.x) / zoom;
            const imgY2 = (crosshair.y - offset.y) / zoom;
            // 지도 좌표계 변환
            const relX2 = Math.max(0, Math.min(1, imgX2 / imgSize.width));
            const relY2 = Math.max(0, Math.min(1, imgY2 / imgSize.height));
            const coordX2 = (mapInfo.max[0] - mapInfo.min[0]) * relX2 + mapInfo.min[0];
            const coordY2 = (mapInfo.max[1] - mapInfo.min[1]) * (1 - relY2) + mapInfo.min[1];
            const dx = Math.abs(coordX2 - pt1.coordX);
            const dy = Math.abs(coordY2 - pt1.coordY);
            tooltipDistance = Math.sqrt(dx * dx + dy * dy) * (mapInfo.distancePerCoord || 1);
            tooltipLeft = ((pt1.imgX + imgX2) / 2) * zoom + offset.x - 30;
            tooltipTop = ((pt1.imgY + imgY2) / 2) * zoom + offset.y - 15;
            tooltipOpacity = 0.5;
          }
          if (tooltipDistance == null) return null;
          return (
            <div
              style={{
                position: "absolute",
                left: tooltipLeft,
                top: tooltipTop,
                background: "#fff",
                color: "#d81b60",
                border: "1px solid #d81b60",
                borderRadius: "6px",
                padding: "4px 10px",
                fontSize: "1em",
                pointerEvents: "none",
                zIndex: 20,
                boxShadow: "0 2px 8px rgba(216,27,96,0.08)",
                whiteSpace: "nowrap",
                fontWeight: "bold",
                opacity: tooltipOpacity,
              }}
            >
              {tooltipDistance.toFixed(1)} m
            </div>
          );
        })()}
        {/* 십자선 */}
        {crosshair.show && (
          <>
            {/* 수직 십자선 */}
            <div
              style={{
                position: "absolute",
                left: crosshair.x,
                top: 0,
                width: "2px",
                height: "100%",
                background: "cyan", // 색상 변경
                opacity: 0.5,
                pointerEvents: "none",
                transform: "translateX(-1px)",
                zIndex: 2,
              }}
            />
            {/* 수평 십자선 */}
            <div
              style={{
                position: "absolute",
                top: crosshair.y,
                left: 0,
                height: "2px",
                width: "100%",
                background: "cyan", // 색상 변경
                opacity: 0.5,
                pointerEvents: "none",
                transform: "translateY(-1px)",
                zIndex: 2,
              }}
            />
            {/* 좌표 툴팁 */}
            {coordText && (
              (() => {
                // 툴팁 크기 추정값
                const tooltipWidth = 80;
                const tooltipHeight = 32;
                const distanceTooltipWidth = 60;
                const distanceTooltipHeight = 24;
                const padding = 8;
                
                // 기본 위치 (우하단)
                let left = crosshair.x + 6;
                let top = crosshair.y + 4;
                
                // 거리 측정 중일 때 툴팁 겹침 체크
                if (linePoints.length === 1 && crosshair.show) {
                  // 거리 툴팁 위치 계산
                  const pt1 = linePoints[0];
                  const imgX2 = (crosshair.x - offset.x) / zoom;
                  const imgY2 = (crosshair.y - offset.y) / zoom;
                  const distanceTooltipLeft = ((pt1.imgX + imgX2) / 2) * zoom + offset.x - 30;
                  const distanceTooltipTop = ((pt1.imgY + imgY2) / 2) * zoom + offset.y - 15;
                  
                  // 두 툴팁이 겹치는지 확인
                  const coordTooltipRight = left + tooltipWidth;
                  const coordTooltipBottom = top + tooltipHeight;
                  const distanceTooltipRight = distanceTooltipLeft + distanceTooltipWidth;
                  const distanceTooltipBottom = distanceTooltipTop + distanceTooltipHeight;
                  
                  const isOverlapping = !(
                    left > distanceTooltipRight ||
                    coordTooltipRight < distanceTooltipLeft ||
                    top > distanceTooltipBottom ||
                    coordTooltipBottom < distanceTooltipTop
                  );
                  
                  // 겹치는 경우에만 좌표 툴팁을 이동
                  if (isOverlapping) {
                    // 좌표 텍스트 길이에 따른 실제 툴팁 너비 계산
                    const estimatedTextWidth = coordText.length * 10; // 대략적인 글자 너비
                    const actualTooltipWidth = Math.max(tooltipWidth, estimatedTextWidth + 20); // 패딩 포함
                    
                    left = crosshair.x - actualTooltipWidth + 10;
                    top = crosshair.y - tooltipHeight - 4;
                    
                    // 왼쪽 경계 체크
                    if (left < 0) {
                      left = crosshair.x + 6; // 우측으로 이동
                    }
                    // 상단 경계 체크
                    if (top < 0) {
                      top = crosshair.y + 6; // 하단으로 이동
                    }
                  }
                }

                // 이미지 영역 내에서 툴팁이 항상 보이도록 위치 조정
                if (left + tooltipWidth > imgSize.width * zoom + offset.x) {
                  left = imgSize.width * zoom + offset.x - tooltipWidth - padding;
                }
                if (left < 0) left = padding;
                if (top + tooltipHeight > imgSize.height * zoom + offset.y) {
                  top = crosshair.y - tooltipHeight - 6;
                  if (top < 0) top = imgSize.height * zoom + offset.y - tooltipHeight - padding;
                }
                if (top < 0) top = padding;

                return (
                  <div
                    style={{
                      position: "absolute",
                      left,
                      top,
                      background: "#fff",
                      color: "#1e7cda",
                      border: "1px solid #1e7cda",
                      borderRadius: "6px",
                      padding: "4px 10px",
                      fontSize: "1em",
                      pointerEvents: "none",
                      zIndex: 30,
                      boxShadow: "0 2px 8px rgba(30,124,218,0.08)",
                      whiteSpace: "nowrap",
                      maxWidth: tooltipWidth,
                      maxHeight: tooltipHeight,
                      overflow: "hidden",
                    }}
                  >
                    {coordText}
                  </div>
                );
              })()
            )}
          </>
        )}
      </div>
    </div>
    
    {/* 좌표 기록 모달 */}
    {showLocationModal && (
      <div className="location-modal-overlay" onClick={() => setShowLocationModal(false)}>
        <div 
          className="location-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="location-modal-header">
            <h3>좌표 기록</h3>
            <button 
              className="location-modal-close"
              onClick={() => setShowLocationModal(false)}
            >
              ×
            </button>
          </div>
          
          <div className="location-modal-content">
            <div className="location-coord-display">
              <strong>좌표: {modalCoord.x.toFixed(2)}, {modalCoord.y.toFixed(2)}</strong>
            </div>
            
            <div className="location-form-group">
              <label>낚시 유형:</label>
              <div className="location-type-buttons">
                <button 
                  className={`location-type-btn ${locationForm.type === 'float' ? 'active' : ''}`}
                  onClick={() => setLocationForm({...locationForm, type: 'float'})}
                >
                  찌낚시
                </button>
                <button 
                  className={`location-type-btn ${locationForm.type === 'bottom' ? 'active' : ''}`}
                  onClick={() => setLocationForm({...locationForm, type: 'bottom'})}
                >
                  바텀낚시
                </button>
                <button 
                  className={`location-type-btn ${locationForm.type === 'lure' ? 'active' : ''}`}
                  onClick={() => setLocationForm({...locationForm, type: 'lure'})}
                >
                  루어낚시
                </button>
              </div>
            </div>
            
            <div className="location-form-group">
              <label htmlFor="fish">어종:</label>
              <input
                type="text"
                id="fish"
                value={locationForm.fish}
                onChange={(e) => setLocationForm({...locationForm, fish: e.target.value})}
                placeholder="어종을 입력하세요"
                maxLength="50"
              />
            </div>
            
            <div className="location-form-group">
              <label htmlFor="bait">미끼:</label>
              <input
                type="text"
                id="bait"
                value={locationForm.bait}
                onChange={(e) => setLocationForm({...locationForm, bait: e.target.value})}
                placeholder="미끼를 입력하세요"
                maxLength="50"
              />
            </div>
            
            <div className="location-form-group">
              <label htmlFor="memo">메모:</label>
              <textarea
                id="memo"
                value={locationForm.memo}
                onChange={(e) => setLocationForm({...locationForm, memo: e.target.value})}
                placeholder="메모를 입력하세요"
                rows="3"
                maxLength="200"
              />
            </div>
            
            <div className="location-modal-buttons">
              <button 
                className="location-save-btn"
                onClick={saveLocation}
              >
                저장
              </button>
              <button 
                className="location-cancel-btn"
                onClick={() => setShowLocationModal(false)}
              >
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* 좌표 편집 모달 */}
    {showEditModal && editingLocation && (
      <div className="location-modal-overlay" onClick={() => setShowEditModal(false)}>
        <div 
          className="location-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="location-modal-header">
            <h3>좌표 편집</h3>
            <button 
              className="location-modal-close"
              onClick={() => setShowEditModal(false)}
            >
              ×
            </button>
          </div>
          
          <div className="location-modal-content">
            <div className="location-coord-display">
              <strong>좌표: {parseFloat(editingLocation.coord_x).toFixed(2)}, {parseFloat(editingLocation.coord_y).toFixed(2)}</strong>
            </div>
            
            <div className="location-form-group">
              <label>낚시 유형:</label>
              <div className="location-type-buttons">
                <button 
                  className={`location-type-btn ${editForm.type === 'float' ? 'active' : ''}`}
                  onClick={() => setEditForm({...editForm, type: 'float'})}
                >
                  찌낚시
                </button>
                <button 
                  className={`location-type-btn ${editForm.type === 'bottom' ? 'active' : ''}`}
                  onClick={() => setEditForm({...editForm, type: 'bottom'})}
                >
                  바텀낚시
                </button>
                <button 
                  className={`location-type-btn ${editForm.type === 'lure' ? 'active' : ''}`}
                  onClick={() => setEditForm({...editForm, type: 'lure'})}
                >
                  루어낚시
                </button>
              </div>
            </div>
            
            <div className="location-form-group">
              <label htmlFor="edit-fish">어종:</label>
              <input
                type="text"
                id="edit-fish"
                value={editForm.fish}
                onChange={(e) => setEditForm({...editForm, fish: e.target.value})}
                placeholder="어종을 입력하세요"
                maxLength="50"
              />
            </div>
            
            <div className="location-form-group">
              <label htmlFor="edit-bait">미끼:</label>
              <input
                type="text"
                id="edit-bait"
                value={editForm.bait}
                onChange={(e) => setEditForm({...editForm, bait: e.target.value})}
                placeholder="미끼를 입력하세요"
                maxLength="50"
              />
            </div>
            
            <div className="location-form-group">
              <label htmlFor="edit-memo">메모:</label>
              <textarea
                id="edit-memo"
                value={editForm.memo}
                onChange={(e) => setEditForm({...editForm, memo: e.target.value})}
                placeholder="메모를 입력하세요"
                rows="3"
                maxLength="200"
              />
            </div>
            
            <div className="location-modal-buttons">
              <button 
                className="location-save-btn"
                onClick={updateLocation}
              >
                수정
              </button>
              <button 
                className="location-delete-btn"
                onClick={deleteLocation}
                style={{
                  backgroundColor: '#dc3545',
                  borderColor: '#dc3545'
                }}
              >
                삭제
              </button>
              <button 
                className="location-cancel-btn"
                onClick={() => setShowEditModal(false)}
              >
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* 삭제 확인 모달 */}
    {showDeleteModal && (
      <div className="location-modal-overlay" onClick={() => setShowDeleteModal(false)}>
        <div 
          className="location-modal"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: '400px' }}
        >
          <div className="location-modal-header">
            <h3>삭제 확인</h3>
            <button 
              className="location-modal-close"
              onClick={() => setShowDeleteModal(false)}
            >
              ×
            </button>
          </div>
          
          <div className="location-modal-content">
            <div style={{ textAlign: 'center' }}>
              <p style={{ fontSize: '16px', marginBottom: '10px' }}>
                이 좌표를 삭제하시겠습니까?
              </p>
              {editingLocation && (
                <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                  좌표: {parseFloat(editingLocation.coord_x).toFixed(2)}, {parseFloat(editingLocation.coord_y).toFixed(2)}
                  <br />
                  유형: {
                    editingLocation.type === 'float' ? '찌낚시' :
                    editingLocation.type === 'bottom' ? '바텀' :
                    editingLocation.type === 'lure' ? '루어' :
                    editingLocation.type
                  }
                </p>
              )}
            </div>
            
            <div className="location-modal-buttons">
              <button 
                className="location-delete-btn"
                onClick={confirmDelete}
                style={{
                  backgroundColor: '#dc3545',
                  borderColor: '#dc3545'
                }}
              >
                삭제
              </button>
              <button 
                className="location-cancel-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                취소
              </button>
            </div>
          </div>
        </div>
      </div>
    )}

    {/* 데이터 임포트 모달 */}
    {showImportModal && (
      <div className="location-modal-overlay" onClick={() => setShowImportModal(false)}>
        <div 
          className="location-modal"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: '800px', maxHeight: '90vh', overflow: 'auto' }}
        >
          <div className="location-modal-header">
            <h3>📥 기존 맵 데이터 가져오기</h3>
            <button 
              className="location-modal-close"
              onClick={() => setShowImportModal(false)}
            >
              ×
            </button>
          </div>
          
          <div className="location-modal-content">
            <div className="location-form-group">
              <label htmlFor="import-map-select">지도 선택:</label>
              <select
                id="import-map-select"
                value={importForm.mapName}
                onChange={(e) => setImportForm({...importForm, mapName: e.target.value})}
                className="interactive-maps-select"
                style={{ width: '100%' }}
              >
                <option value="">지도를 선택하세요</option>
                {MAP_LIST.map((map) => (
                  <option key={map.file} value={map.file.replace(/\.(webp|jpg|jpeg|png)$/i, '')}>
                    {map.name}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="location-form-group">
              <label htmlFor="coord-data">좌표 데이터:</label>
              <div className="import-help-box">
                <div className="import-help-title">
                  📋 사용 방법:
                </div>
                <div className="import-help-step">
                  1. 추가할 맵을 위에서 선택 해주세요
                </div>
                <div className="import-help-step">
                  2. 기존 맵 프로그램 폴더의 <strong>[맵이름].cfg 파일</strong>을 메모장으로 열어주세요
                </div>
                <div className="import-help-step">
                  3. .cfg 파일의 내용을 모두 복사해주세요
                </div>
                <div className="import-help-step">
                  4. 아래 입력창에 붙여넣기 하고 미리보기를 눌러주세요
                </div>
                <div className="import-help-format">
                  예시: Coord = 1:0:0:38:56:null:null:null;2:323:245:98:111: 1: 2: 3;1:2:594:45:54: : : ;1:233:149:83:127: 123: 123: 123;1:152:231:70:113: : : ;
                </div>
              </div>
              <textarea
                id="coord-data"
                value={importForm.coordData}
                onChange={(e) => setImportForm({...importForm, coordData: e.target.value})}
                placeholder="Coord = 1:0:0:38:56:null:null:null;2:323:245:98:111: 1: 2: 3;1:2:594:45:54: : : ;1:233:149:83:127: 123: 123: 123;1:152:231:70:113: : : ;"
                rows="8"
                style={{ 
                  width: '100%', 
                  fontFamily: 'monospace', 
                  fontSize: '12px',
                  resize: 'vertical'
                }}
              />
            </div>
            
            <div className="location-modal-buttons">
              <button 
                className="location-save-btn"
                onClick={handlePreviewData}
                style={{ backgroundColor: '#17a2b8', borderColor: '#17a2b8' }}
              >
                미리보기
              </button>
              {showPreview && parsedData.length > 0 && (
                <button 
                  className="location-save-btn"
                  onClick={handleImportData}
                  style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                >
                  저장 ({parsedData.length}개)
                </button>
              )}
              <button 
                className="location-cancel-btn"
                onClick={() => {
                  setShowImportModal(false);
                  setImportForm({ mapName: '', coordData: '' });
                  setParsedData([]);
                  setShowPreview(false);
                }}
              >
                취소
              </button>
            </div>
            
            {/* 미리보기 결과 */}
            {showPreview && parsedData.length > 0 && (
              <div style={{ marginTop: '20px' }}>
                <h4>미리보기 결과 ({parsedData.length}개)</h4>
                <div className="import-preview-container">
                  <table className="import-preview-table">
                    <thead>
                      <tr>
                        <th>타입</th>
                        <th>X좌표</th>
                        <th>Y좌표</th>
                        <th>어종</th>
                        <th>미끼</th>
                        <th>메모</th>
                      </tr>
                    </thead>
                    <tbody>
                      {parsedData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.typeText}</td>
                          <td>{item.coordX}</td>
                          <td>{item.coordY}</td>
                          <td>{item.fish || '-'}</td>
                          <td>{item.bait || '-'}</td>
                          <td>{item.memo || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )}

    {/* 좌표 검색 모달 */}
    {coordSearchModalOpen && (
      <div className="location-modal-overlay" onClick={() => setCoordSearchModalOpen(false)}>
        <div 
          className="location-modal"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: '600px' }}
        >
          <div className="location-modal-header">
            <h3>🔍 내 좌표 검색</h3>
            <button 
              className="location-modal-close"
              onClick={() => setCoordSearchModalOpen(false)}
            >
              ×
            </button>
          </div>
          
          <div className="location-modal-body" style={{ padding: '20px', backgroundColor: 'var(--bg-primary)', color: 'var(--text-primary)' }}>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: 'var(--text-primary)' }}>
                검색할 지도 선택:
              </label>
              <select
                value={searchMapName}
                onChange={(e) => setSearchMapName(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px',
                  border: '1px solid var(--border-color)',
                  borderRadius: '4px',
                  fontSize: '14px',
                  marginBottom: '10px',
                  boxSizing: 'border-box',
                  backgroundColor: 'var(--bg-primary)',
                  color: 'var(--text-primary)'
                }}
              >
                <option value="all">전체 지도</option>
                {MAP_LIST.map((map) => (
                  <option key={map.file} value={map.file.replace(/\.(webp|jpg|jpeg|png)$/i, '')}>
                    {map.name}
                  </option>
                ))}
              </select>
            </div>
            
            <div style={{ marginBottom: '15px' }}>
              <input
                type="text"
                placeholder="물고기명, 미끼, 메모로 검색..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  // 입력값이 변경되면 이전 검색 결과와 실행 상태 초기화
                  if (e.target.value.trim() === '') {
                    setSearchResults([]);
                    setSearchExecuted(false);
                  }
                }}
                onKeyPress={(e) => e.key === 'Enter' && searchTerm.trim() && searchCoordinates()}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid var(--border-color)',
                  borderRadius: '4px',
                  fontSize: '14px',
                  boxSizing: 'border-box',
                  backgroundColor: 'var(--bg-primary)',
                  color: 'var(--text-primary)'
                }}
              />
            </div>
            
            <div style={{ marginBottom: '15px', textAlign: 'center' }}>
              <button
                className="interactive-maps-btn"
                onClick={searchCoordinates}
                disabled={searchLoading || !searchTerm.trim()}
                style={{
                  padding: '10px 20px',
                  cursor: (searchLoading || !searchTerm.trim()) ? 'not-allowed' : 'pointer',
                  opacity: (searchLoading || !searchTerm.trim()) ? 0.6 : 1
                }}
              >
                {searchLoading ? '검색 중...' : '검색'}
              </button>
            </div>

            {searchResults.length > 0 && (
              <div>
                <h4 style={{ marginBottom: '10px', color: 'var(--text-primary)' }}>검색 결과 ({searchResults.length}개)</h4>
                <div style={{ 
                  maxHeight: '300px', 
                  overflowY: 'auto', 
                  border: '1px solid var(--border-color)', 
                  borderRadius: '4px',
                  backgroundColor: 'var(--bg-primary)'
                }}>
                  {searchResults.map((result, index) => (
                    <div 
                      key={`${result.id}-${index}`}
                      onClick={() => handleSearchResultClick(result)}
                      style={{
                        padding: '12px',
                        borderBottom: '1px solid var(--border-light)',
                        cursor: 'pointer',
                        backgroundColor: 'var(--bg-primary)',
                        transition: 'background-color 0.2s',
                        color: 'var(--text-primary)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--hover-bg)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--bg-primary)';
                      }}
                    >
                      <div style={{ fontWeight: 'bold', color: '#007bff', marginBottom: '4px' }}>
                        {getKoreanMapName(result.map_name)} - ({result.coord_x}, {result.coord_y})
                      </div>
                      {result.fish && (
                        <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '2px' }}>
                          🐟 물고기: {result.fish}
                        </div>
                      )}
                      {result.bait && (
                        <div style={{ fontSize: '12px', color: 'var(--text-secondary)', marginBottom: '2px' }}>
                          🎣 미끼: {result.bait}
                        </div>
                      )}
                      {result.memo && (
                        <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                          📝 메모: {result.memo}
                        </div>
                      )}
                      <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '4px' }}>
                        {new Date(result.created_at).toLocaleString('ko-KR')}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {searchExecuted && searchResults.length === 0 && !searchLoading && (
              <div style={{ textAlign: 'center', color: 'var(--text-secondary)', padding: '20px' }}>
                검색 결과가 없습니다.
              </div>
            )}
          </div>
        </div>
      </div>
    )}

    {/* 사용법 모달 */}
    {showHelpModal && (
      <div className="location-modal-overlay" onClick={() => setShowHelpModal(false)}>
        <div 
          className="location-modal"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: '600px' }}
        >
          <div className="location-modal-header">
            <h3>📖 반응형 지도 사용법</h3>
            <button 
              className="location-modal-close"
              onClick={() => setShowHelpModal(false)}
            >
              ×
            </button>
          </div>
          
          <div className="location-modal-content">
            <div className="help-modal-content">
              <h4 className="help-modal-section-title">🎯 기본 조작</h4>
              <ul className="help-modal-list">
                <li><strong>좌클릭:</strong> 좌표 표시 및 거리 측정 시작</li>
                <li><strong>우클릭:</strong> 해당 좌표에 마커 저장</li>
                <li><strong>드래그:</strong> 지도 이동 (확대된 상태에서)</li>
                <li><strong>휠 스크롤:</strong> 지도 확대/축소</li>
              </ul>

              <h4 className="help-modal-section-title">📏 거리 측정</h4>
              <ul className="help-modal-list">
                <li>첫 번째 좌클릭으로 시작점 설정</li>
                <li>두 번째 좌클릭으로 끝점 설정하면 거리 계산</li>
                <li>ESC키 또는 더블클릭으로 측정 초기화</li>
              </ul>

              <h4 className="help-modal-section-title">📍 좌표 검색</h4>
              <ul className="help-modal-list">
                <li>X, Y 좌표를 입력하고 검색 버튼 클릭</li>
                <li>해당 위치에 파란색 검색 마커 표시</li>
              </ul>

              <h4 className="help-modal-section-title">💾 마커 저장</h4>
              <ul className="help-modal-list">
                <li>원하는 위치에서 우클릭</li>
                <li>마커 종류 선택 (찌낚시, 바텀, 루어)</li>
                <li>물고기, 미끼, 메모 정보 입력</li>
                <li>저장된 마커는 지도에 색상별로 표시</li>
              </ul>

              <h4 className="help-modal-section-title">✏️ 마커 관리</h4>
              <ul className="help-modal-list">
                <li>저장된 마커에 마우스를 올리면 정보 툴팁 표시</li>
                <li>마커 클릭하여 정보 수정 또는 삭제 가능</li>
                <li>로그인한 사용자만 마커 저장/수정 가능</li>
              </ul>

              <h4 className="help-modal-section-title">🗺️ 지도 전환</h4>
              <ul style={{ marginBottom: '10px', paddingLeft: '20px' }}>
                <li>상단 드롭다운에서 다른 지도 선택 가능</li>
                <li>각 지도는 독립적인 좌표계와 마커 정보 보유</li>
              </ul>

              <div className="help-modal-tip-box">
                <strong>💡 마커 색상 의미</strong> <br/>
                &nbsp;&nbsp;🔵 <strong>찌낚시:</strong> 찌낚시 포인트<br/>
                &nbsp;&nbsp;🟤 <strong>바텀:</strong> 바텀 낚시 포인트<br/>
                &nbsp;&nbsp;🟢 <strong>루어:</strong> 루어 낚시 포인트<br/>
                &nbsp;&nbsp;🔍 <strong>검색 마커:</strong> 좌표 검색 결과
              </div>
            </div>
          </div>

          <div className="help-modal-buttons">
            <button 
              className="help-modal-confirm-btn"
              onClick={() => setShowHelpModal(false)}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    )}
    <Comments pageName="interactive_maps" />
    </>
  );
}
